<ng-content></ng-content>
<i
  class="fa"
  [ngClass]="isMasked ? 'fa-eye-slash':'fa-eye'"
  [title]="isMasked ? strings.unmask : strings.mask"
  (click)="toggleAsterisks()"
  *ngIf="!hideMask"></i>
